/* This Source Code Form is subject to the terms of the Mozilla Public
* License, v. 2.0. If a copy of the MPL was not distributed with this
* file, You can obtain one at http://mozilla.org/MPL/2.0/. */



export const DASHBOARD_IMPORT_EXPORT = "dashboard-import-export-dialog";
export const DATASOURCE_CONFIG = "datasource-config-dialog";
export const WIDGET_CONFIG = "widget-config-dialog";
export const PLUGINS = "plugins-dialog";


/** WEBPACK FOOTER **
 ** ./src/modal/modalDialogIds.ts
 **/